import {Box, HBox} from '../../../components/core/view';
import {ChevronDownIcon, ChevronUpIcon} from 'native-base';
import React, {useCallback} from 'react';
import {
  batchDetailActionsLocal,
  useBatchDetailContext,
} from '../../../batchDetails/hooks/batchDetail';

import {Analytics} from '../../../config/analytics/analytics';
import {EventType} from '../../../config/analytics/type';
import {H6Text} from '../../../components/core/text';
import HorizontalBars from '../../../components/core/icon/HorizontalBars';
import {Info} from '@buncha/components/core/icon';
import {Modules} from '@buncha/utils/types';
import {ShopperScreens} from '@buncha/home/navigation/types';
import {Touchable} from '../../../components/core/touchable';
import {getClientType} from '@buncha/common/types/common';
import {itemsSortBy} from '../../../batchDetails/types';
import {styles} from './styles';
import {useColorThemeType} from '../../../appStyles/hooks/theme';
import {useGetLocale} from '@buncha/localization/hooks';

const SortBar = (props: {upcMode?: boolean; isMeijer: boolean}) => {
  const theme = useColorThemeType();
  const {state, dispatch} = useBatchDetailContext();
  const isB2BStore = state.isB2bStore;
  const currentSortValue = state.sortBarValue;
  const defaultSort = currentSortValue === itemsSortBy.category;
  const {body} =
    useGetLocale(Modules.batchDetails, ShopperScreens.BatchDetailsPage) ?? {};
  const changeSort = useCallback(() => {
    Analytics.eventWithProps('Change Sort', {
      type: EventType.cta,
      currentSortValue: currentSortValue || itemsSortBy.category,
      changeSortValueTo: defaultSort
        ? itemsSortBy.customer
        : itemsSortBy.category,
      client: getClientType(isB2BStore),
    });
    if (dispatch) {
      dispatch(batchDetailActionsLocal.clearGroupedAssignedItems());
      if (defaultSort)
        dispatch(batchDetailActionsLocal.setSortBarValue(itemsSortBy.customer));
      else
        dispatch(batchDetailActionsLocal.setSortBarValue(itemsSortBy.category));
    }
  }, [currentSortValue, defaultSort, dispatch, isB2BStore]);

  const getRightIcon = useCallback(() => {
    if (defaultSort)
      return (
        <Box>
          <ChevronDownIcon
            size={3}
            color={theme?.text.gray[100]}
            style={[styles.sortIcon]}
          />
          <ChevronUpIcon
            size={3}
            color={theme?.text.gray[100]}
            style={[styles.sortIcon]}
          />
        </Box>
      );
    return (
      <Box>
        <ChevronUpIcon
          size={3}
          color={theme?.text.gray[100]}
          style={[styles.sortIcon]}
        />
        <ChevronDownIcon
          size={3}
          color={theme?.text.gray[100]}
          style={[styles.sortIcon]}
        />
      </Box>
    );
  }, [defaultSort, theme?.text.gray]);

  const getText = useCallback(() => {
    if (state.sortBarValue === itemsSortBy.category)
      return props.isMeijer ? body?.sort?.zone : body?.sort?.category;
    return body?.sort?.customer;
  }, [
    body?.sort?.category,
    body?.sort?.customer,
    body?.sort?.zone,
    props.isMeijer,
    state.sortBarValue,
  ]);

  if (props.upcMode)
    return (
      <HBox
        style={[
          styles.mainContainer,
          styles.UPCmainContainer,
          {
            borderColor: theme?.background.gray[100],
            backgroundColor: theme?.background.gray[200],
          },
        ]}>
        <Info viewBox="0 -4.5 28 28" fill={theme?.background.gray[100]} />
        <H6Text>{body?.scanItemUPC}</H6Text>
      </HBox>
    );
  return (
    <Touchable onPress={changeSort}>
      <Box
        style={[
          styles.mainContainer,
          {
            borderColor: theme?.background.gray[100],
            backgroundColor: theme?.background.gray[200],
          },
        ]}>
        <Box style={[styles.subContainer]}>
          <HBox>
            <HBox style={[styles.sortContainer]}>
              <HorizontalBars
                width={24}
                height={24}
                fill={theme?.background.gray[100]}
                viewBox="0 -5 30 20"
              />
              <H6Text style={[styles.sortText]}>
                {body?.sort?.sort}
                {getText()}
              </H6Text>
            </HBox>
            <HBox>{getRightIcon()}</HBox>
          </HBox>
        </Box>
      </Box>
    </Touchable>
  );
};

export default React.memo(SortBar);
